<div class="row">
  <div class="col-12 col-md-4 text-center border-end">
    <!-- Discount type -->
    <h5 class="text-danger" *ngIf="couponPreviewData?.coupon_discount.discount_id == 1 && couponPreviewData?.coupon_discount.dollar_discount_compare == 0">Save ${{ couponPreviewData?.coupon_discount.discount_lower }}</h5>
    
    <h5 class="text-danger" *ngIf="couponPreviewData?.coupon_discount.discount_id == 1 && couponPreviewData?.coupon_discount.dollar_discount_compare == 1">
      <span style="text-decoration: line-through; color: grey;">${{ couponPreviewData?.coupon_discount.discount_lower }}</span>
      ${{ couponPreviewData?.coupon_discount.discount_upper }}
    </h5>

    <h5 class="text-danger" *ngIf="couponPreviewData?.coupon_discount.discount_id == 2">Save {{ couponPreviewData?.coupon_discount.discount_lower }}%</h5>
    
    <h5 class="text-danger" *ngIf="couponPreviewData?.coupon_discount.discount_id == 3">Buy {{ couponPreviewData?.coupon_discount.discount_lower }} Get {{ couponPreviewData?.coupon_discount.discount_upper }}</h5>

    <!-- Image -->
    <img class="img-fluid mt-1 mb-2" [src]="couponPreviewData.coupon_image" alt="...">

    <!-- Date -->
    <span class="modal-coupon-date text-muted text-center">
      {{ couponPreviewData.start_date | date : 'MMM d, y' : 'UTC' }} - {{ couponPreviewData.coupon_expiration.date | date : 'MMM d, y' : 'UTC' }}
    </span>
  </div>
  <div class="col-12 col-md-8">
    <!-- Quantity per Transaction -->
    <div class="modal-sub-title text-muted">Quantity per Transaction : <span class="qty-per-transaction text-muted fw-normal">{{ couponPreviewData.max_redeem_quantity }}</span></div>

    <!-- Max Redemptions -->
    <div class="modal-sub-title text-muted mt-2">Max Redemptions : <span class="max-redemptions text-muted fw-normal">{{ couponPreviewData.coupon_expiration.counter }}</span></div>

    <!-- Products -->
    <div class="modal-sub-title text-muted mt-2">Products ({{ couponPreviewData.products.length }})</div>
    <div *ngFor="let product of couponPreviewData.products; let i = index;">
      <span class="modal-products text-muted">{{ product.item_name }} ({{ product.upc }})<span *ngIf="i < couponPreviewData.products.length-1">,</span> </span>
    </div>

    <!-- Categories -->
    <div class="modal-sub-title text-muted mt-2" *ngIf="couponPreviewData?.categories.length > 0">Categories ({{ couponPreviewData.categories.length }})</div>
    <div *ngFor="let category of couponPreviewData.categories; let i = index;">
      <span class="modal-products text-muted">{{ category.category_name }} <span *ngIf="i < couponPreviewData.categories.length-1">,</span> </span>
    </div>

    <!-- Manufacturer -->
    <div class="modal-sub-title text-muted mt-2" *ngIf="couponPreviewData?.mfg_name">Manufacturer</div>
    <div class="modal-terms text-muted" *ngIf="couponPreviewData?.mfg_name">{{ couponPreviewData.mfg_name }}</div>

    <!-- Brand -->
    <div class="modal-sub-title text-muted mt-2" *ngIf="couponPreviewData?.brand_name">Brand</div>
    <div class="modal-terms text-muted" *ngIf="couponPreviewData?.brand_name">{{ couponPreviewData.brand_name }}</div>

    <!-- Terms -->
    <div class="modal-sub-title text-muted mt-2">Terms</div>
    <div class="modal-terms text-muted">{{ couponPreviewData.terms }}</div>
  </div>
</div>
